import React from "react";
import { Row } from "react-bootstrap";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import BulletCard from "../Elements/BulletCard.jsx";
import CountrySelectorIntl from "../Elements/CountrySelectorIntl";
import constants from "../../../config/constants.js";
import { GetBulletsForCountrySelectionIntl } from "../../GetBulletInfo/GetBulletInfo";

const FirstPageIntl = () => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(constants.LANGUAGE_CODE_EN);
  }, [i18n]);

  return (
    <section className="multi_content">
      <Row style={{ gap: "36px", justifyContent: "space-between" }}>
        <BulletCard
          className="d-none d-lg-block"
          bullets={GetBulletsForCountrySelectionIntl()}
          title={t("content.intlHomeInstructionsTitle")}
          titleDescription={t("content.intlHomeInstructions")}
          subTitle={t("content.intlHomeInstructionsSubTitle")}
          footer={[
            t("content.intlHomeInstructionsFooterText"),
            { linkText: t("content.intlSupportEmail"), linkUrl: "" }
          ]}
        />
        <CountrySelectorIntl countryUser={constants.COUNTRY_CODE_INTL} />
      </Row>
    </section>
  );
};

export default FirstPageIntl;
